
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
  name: 'ContainerBlock',

  computed: {
    dopClasses: function () {
      const list = [];
      if ((this.values.hidden || '').indexOf('d-sm-none') > -1) {
        list.push('hidden-pc');
      }
      if ((this.values.hidden || '').indexOf('d-none') > -1) {
        list.push('hidden-mobile');
      }
      return list.join(' ');
    },
  },
});
